import { ReactNode } from 'react';
import Image from 'next/image';

import { Box, Flex, Text } from '@chakra-ui/react';

import { HeadingWithEmphasis, HeadingWithEmphasisProps } from '~/components/heading-with-emphasis';

export type DiscountCardHeaderProps = {
  icon: ReactNode;
  preTitle: string;
  preTitleColor?: string;
  lineColor?: string;
  title: string;
  emphasisProps?: HeadingWithEmphasisProps['emphasisProps'];
  subtitle?: string;
};

export function DiscountCardHeader({
  icon,
  preTitle,
  preTitleColor = 'white',
  lineColor = 'grey.100',
  title,
  emphasisProps,
  subtitle,
}: DiscountCardHeaderProps) {
  return (
    <Box
      bgGradient='linear(180deg, #20003A 0%, #6100B0 100%)'
      color='white'
      overflow='hidden'
      paddingX='24px'
      paddingY='24px'
      position='relative'
      textAlign='center'
      borderRadius={{
        base: '6px 6px 0px 0px',
        md: '6px',
      }}
    >
      <Box
        height='526px'
        left='50%'
        pointerEvents='none'
        position='absolute'
        top='50%'
        transform='translate(-50%, -50%)'
        width='526px'
      >
        <Image alt='' height={526} src='/images/personalized-discount/header-bg-decoration.svg' width={526} />
      </Box>

      <Flex alignItems='center' direction='column' gap='12px' position='relative'>
        {icon}

        <Flex alignItems='center' gap='16px' width='100%'>
          <Box bg={lineColor} flex='1' height='0.5px' />
          <Text
            color={preTitleColor}
            fontFamily='condensed'
            fontSize='15px'
            fontWeight={500}
            letterSpacing='0.06em'
            lineHeight='1em'
            textTransform='uppercase'
          >
            {preTitle}
          </Text>
          <Box bg={lineColor} flex='1' height='0.5px' />
        </Flex>

        <HeadingWithEmphasis
          emphasisProps={emphasisProps}
          text={title}
          headingProps={{
            as: 'h1',
            fontFamily: 'heading',
            fontSize: { base: '28px', md: '40px' },
            fontWeight: 600,
            letterSpacing: '-0.01em',
            lineHeight: '1.1em',
          }}
        />

        {subtitle && (
          <Text color='grey.200' fontSize='16px' fontWeight={400} lineHeight='1.5em'>
            {subtitle}
          </Text>
        )}
      </Flex>
    </Box>
  );
}
